import Http from "../Http";
import { INSPECTION_URL } from "../Helper";

export function getCleaningRestorationProfileData(profile_id) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.get(INSPECTION_URL + 'get_cleaning_restoration_profile/' + (profile_id || 0))
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
}

export function updateCleaningRestorationProfile(values) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.post(INSPECTION_URL + 'update_cleaning_restoration_profile/', values)
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
}
